export default {
    state: {
      new_invites: [],
      edit_event: null,
      edit_place: null,
      new_type: 'events'
    },
    mutations: {
      changeInvite(state, user) {
        let finded = state.new_invites.find(item => user.id === item.id);
        finded ? state.new_invites.splice(this.new_invites.indexOf(finded), 1) : state.new_invites.push(user)
      },
      clearNewInvites(state) {
        state.new_invites = [];
      },
      setEditEvent(state, event) {
        state.edit_event = event;
      },
      setEditPlace(state, place) {
        state.edit_place = place;
      },
      setNewType(state, type) {
        state.new_type = type;
      },
    },
    actions: {
      setNewType({commit}, type) {
        commit('setNewType', type)
      },
      editEvent({commit}, event) {
        commit('setEditEvent', event)
      },
      editPlace({commit}, place) {
        commit('setEditPlace', place)
      },
      changeInviteNew({ commit }, user) {
        commit('changeInvite', user);
      },
      clearNewInvites({ commit }) {
        commit('clearNewInvites');
      },
    },
    getters: {
      getNewInvites: (s) => s.new_invites,
      getEditEvent: s => s.edit_event,
      getEditPlace: s => s.edit_place,
      getNewType: s => s.new_type,
    },
  };
  